import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { PRIORITY_TASK_MENU_CURATION_TASKS } from '../graphql/queries'
import { FETCH_PRIORITY_TASK_MENU_CURATION_TASKS } from '../redux/action-types'

const usePriorityTasksMenuCurationTasksQuery = (
  { priorityTaskId, allocatedUserId, allocationStatus } = {},
  { pageSize, currentPage } = {},
) => {
  const dispatch = useDispatch()

  const {
    areMenuCurationTasksLoading: isLoading,
    menuCurationTasksError: error,
    menuCurationTasks: data,
  } = useSelector(store => store.priorityTasks.priorityTask)

  const refetch = useCallback(
    (filtersParam, paginationParam) => {
      apolloService.query({
        query: PRIORITY_TASK_MENU_CURATION_TASKS,
        variables: {
          filters: filtersParam,
          pagination: paginationParam,
        },
        dispatch,
        action: FETCH_PRIORITY_TASK_MENU_CURATION_TASKS,
      })
    },
    [dispatch],
  )

  useEffect(() => {
    refetch(
      {
        priorityTaskId,
        allocatedUserId,
        allocationStatus,
      },
      { pageSize, currentPage },
    )
  }, [
    priorityTaskId,
    allocatedUserId,
    allocationStatus,
    pageSize,
    currentPage,
    refetch,
  ])

  return { isLoading, error, data }
}

export default usePriorityTasksMenuCurationTasksQuery
